import { array, object, string } from "yup";
import i18next from "i18next";

const schema = object().shape(
  {
    name: string().default("").required(i18next.t("feedback.nameCantBeBlank")),
    email: string()
      .default("")
      .required(i18next.t("feedback.emailCantBeBlank"))
      .email(i18next.t("feedback.invalidEmail")),
    // can't using default value in schema cuz it prevent key havigation
    reason: string().required(i18next.t("feedback.typeCantBeBlank")),
    comments: string()
      .default("")
      .required(i18next.t("feedback.commentCantBeBlank")),
    featureAvailable: string().default(""),
    isThisDigital: string().default(""),
    primaryValueThisFeature: string().default(""),
    thisFunctionalityInOurCompetitors: string().default(""),
    ifThisSuggestionIsImplemented: string().default(""),
    loadedFiles: array().default([]),
  },
  [],
);

export const validation = { schema, initialValues: schema.cast({}) };
